import { httpClient } from "@/lib/httpClient";

export interface SearchHit {
  pageId: string;
  sectionSlug: string;
  sectionTitle: string;
  pageSlug: string;
  title: string;
  snippet: string;
  rank: number;
}

export interface SearchResponse {
  query: string;
  hits: SearchHit[];
}

export const searchService = {
  search: (q: string) => httpClient.get<SearchResponse>(`/api/search?q=${encodeURIComponent(q)}`),
};
